import { useEffect } from 'react';
import "./PrivacyPolicy.css";

export default function PrivacyPolicy() {
    useEffect(() => {
        document.title = 'מדיניות פרטיות | ZmanUp';
    }, []);

    const handleBack = () => {
        if (window.history.length > 1) {
            window.history.back();
        } else {
            window.location.href = '/';
        }
    };

    return (
        <main className="privacy-policy-container" dir="rtl">
            <article className="privacy-policy-content">
                <button type="button" className="privacy-policy-back" onClick={handleBack}>
                    → חזרה
                </button>

                <h1 className="privacy-policy-title">מדיניות פרטיות – ZmanUp</h1>
                <p className="privacy-policy-subtitle">עודכן לאחרונה: [ספטמבר 2026]</p>

                <p className="privacy-policy-text">
                    מדיניות פרטיות זו מסבירה איזה מידע אנו אוספים, לאילו מטרות, עם מי הוא משותף ומהן זכויותיך. המדיניות חלה על האתרים zmanup.co.il ו-zmanup.com, על אפליקציות ZmanUp ל-iOS ול-Android ועל כל השירותים הקשורים בהם (להלן יחד: "השירות").
                    <br />
                    המדיניות מנוסחת בלשון זכר מטעמי נוחות בלבד ומתייחסת לכל המגדרים.
                </p>

                <h2 className="privacy-policy-heading">1. מי אנחנו</h2>
                <p className="privacy-policy-text">
                    השירות מופעל על ידי מיכאל מלז׳יק, עוסק פטור מס' 334018512, הפועל תחת השם המסחרי ZmanUp, (להלן: "ZmanUp" או "אנו").
                    <br />
                    לכל פנייה בנושא פרטיות:{' '}
                    <a href="mailto:support@zmanup.co.il">support@zmanup.co.il</a>
                </p>

                <h2 className="privacy-policy-heading">2. למי המדיניות מתייחסת ומה תפקידנו</h2>
                <p className="privacy-policy-text">
                    2.1 בעלי עסקים – מאסטרים, סלונים ועובדיהם שנרשמים לשירות ומשתמשים בו לניהול יומן ותורים (להלן: "משתמש עסקי"). לגבי מידע ש-ZmanUp אוספת ומעבדת לצורך ניהול החשבון, אספקת השירות, חיוב, תמיכה, אבטחה ועמידה בדרישות הדין, ZmanUp היא בעלת השליטה במאגר המידע.
                    <br />
                    2.2 לקוחות של בעלי העסקים – אנשים שקובעים תור אצל עסק באמצעות השירות, או שהעסק מזין את פרטיהם לשירות (להלן: "לקוח קצה"). לגבי מידע שהעסק אוסף ומנהל על לקוחותיו לצורכי ניהול התורים, מתן השירות והקשר עם הלקוח, העסק הוא בעל השליטה במאגר המידע, ו-ZmanUp פועלת כמחזיק ומעבדת את המידע בשמו ובהתאם להוראותיו, לצורך אספקת השירות.
                    <br />
                    לקוח קצה המבקש לעיין במידע עליו, לתקנו או למחקו, מתבקש לפנות תחילה לעסק שאצלו קבע תור. ZmanUp תסייע לעסק בטיפול בבקשה. ניתן גם לפנות אלינו ישירות, ונעביר את הפנייה לעסק הרלוונטי.
                    <br />
                    2.3 משתמש עסקי המזין לשירות מידע על לקוחותיו אחראי לכך שהוא רשאי לעשות זאת על פי דין, שהמידע נחוץ לצורך מתן השירות ללקוח, ושהלקוח יודע על כך. אין להזין לשירות מידע רגיש (לרבות מידע רפואי) מעבר לנדרש לצורך הטיפול.
                </p>

                <h2 className="privacy-policy-heading">3. איזה מידע אנו אוספים</h2>
                <p className="privacy-policy-text">
                    3.1 משתמשים עסקיים: שם פרטי ושם משפחה, מספר טלפון, כתובת דוא"ל, תאריך לידה, שם העסק וכתובתו, השירותים, המחירים ושעות הפעילות, וכן הגדרות החשבון ונתוני השימוש בשירות.
                    <br />
                    3.2 לקוחות קצה: שם, מספר טלפון, כתובת דוא"ל, פרטי התורים (מועד, שירות, מחיר), היסטוריית ביקורים, וכן הערות שהעסק בוחר לרשום (העשויות לכלול מידע הנוגע לטיפול, כגון רגישויות).
                    <br />
                    3.3 מידע טכני: כתובת IP, סוג המכשיר ומערכת ההפעלה, גרסת האפליקציה, מזהה לשליחת התראות (push token), יומני מערכת (לוגים) ומידע על אופן השימוש באתר ובאפליקציה. מידע זה עשוי לזהות אותך, ולכן אנו מתייחסים אליו כאל מידע אישי.
                    <br />
                    3.4 מידע מחשבון Google – ראו סעיף 9.
                    <br />
                    3.5 מידע על תשלומים – ראו סעיף 6.
                    <br />
                    3.6 אינך חייב על פי חוק למסור לנו מידע. עם זאת, ללא מידע מסוים (למשל מספר טלפון) לא נוכל לספק לך את השירות, כולו או חלקו.
                </p>

                <h2 className="privacy-policy-heading">4. כיצד המידע נאסף</h2>
                <p className="privacy-policy-text">
                    • ממך ישירות – בעת ההרשמה, הגדרת החשבון וקביעת תור.
                    <br />
                    • מהמשתמש העסקי – כאשר הוא מזין לשירות פרטי לקוחות ותורים.
                    <br />
                    • באופן אוטומטי – באמצעות קובצי Cookies, כלים לניתוח שימוש ויומני מערכת.
                    <br />
                    • מ-Google – אם בחרת לחבר את חשבון ה-Google שלך (סעיף 9).
                </p>

                <h2 className="privacy-policy-heading">5. מטרות השימוש במידע</h2>
                <p className="privacy-policy-text">
                    • הפעלת השירות: ניהול יומן, קביעת תורים, אישורים ותזכורות.
                    <br />
                    • ניהול החשבון, תמיכה ומענה לפניות.
                    <br />
                    • אבטחת מידע, מניעת הונאות ומניעת שימוש לרעה.
                    <br />
                    • שיפור השירות, מחקר וניתוח סטטיסטי, ככל האפשר על בסיס מידע מצרפי.
                    <br />
                    • שליחת דברי פרסומת – רק בהסכמה, כמפורט בסעיף 7.
                    <br />
                    • עמידה בדרישות הדין.
                    <br />
                    ZmanUp אינה משתמשת במידע העסקי של לקוחות הקצה לצרכיה העצמאיים או לצורכי שיווק. מבלי לגרוע מכך, ZmanUp רשאית לעבד מידע טכני ומידע הנדרש לצורכי אבטחת השירות, מניעת הונאות, תמיכה, תפעול ועמידה בדרישות הדין, בהתאם למדיניות זו.
                </p>

                <h2 className="privacy-policy-heading">6. תשלומים</h2>
                <p className="privacy-policy-text">
                    6.1 תשלום עבור מנוי ל-ZmanUp: פרטי כרטיס האשראי מוזנים ישירות בעמוד המאובטח של ספק הסליקה, אינם עוברים דרך שרתי ZmanUp ואינם נשמרים בהם. אנו מקבלים מספק הסליקה רק אישור על ביצוע העסקה ופרטים הנחוצים לניהול המנוי ולהנהלת החשבונות.
                    <br />
                    6.2 תשלום של לקוח קצה לעסק: התשלום מתבצע באמצעות ספק הסליקה שבחר העסק, במסגרת היחסים שבין הלקוח, העסק וספק הסליקה. ZmanUp אינה צד לעסקה ואינה מקבלת או שומרת את פרטי כרטיס האשראי. על עיבוד פרטי התשלום חלה מדיניות הפרטיות של ספק הסליקה.
                </p>

                <h2 className="privacy-policy-heading">7. הודעות ודיוור</h2>
                <p className="privacy-policy-text">
                    7.1 הודעות שירות ותפעול – כחלק מהשירות, ZmanUp רשאית לשלוח למשתמשים, באמצעי הקשר שמסרו, הודעות הקשורות באופן סביר להרשמה, להשלמת תהליך ההצטרפות וה-Onboarding, להפעלת החשבון, לאבטחתו, להגדרות החשבון והשירות, לתמיכה, לשימוש בפועל ב-ZmanUp, וכן אישורי תור, תזכורות, שינויים וביטולים והודעות מהותיות הנוגעות לחשבון או לשירות. הודעות אלה עשויות להישלח ב-SMS, ב-WhatsApp, בדוא"ל או בהתראות באפליקציה. הודעות שירות ותפעול אלה אינן מיועדות לפרסום או לשיווק ולא יכללו מבצעים, פרסומות או הצעות שיווקיות שאינן נדרשות לצורך מתן השירות.
                    <br />
                    7.2 דברי פרסומת – מידע על מוצרים, שירותים ומבצעים של ZmanUp – יישלחו אליך רק אם נתת לכך הסכמה מפורשת מראש, בהתאם לסעיף 30א לחוק התקשורת (בזק ושידורים), התשמ"ב-1982.
                    <br />
                    7.3 ניתן לבטל את ההסכמה לקבלת דברי פרסומת בכל עת וללא עלות: באמצעות קישור ההסרה המופיע בכל הודעה שיווקית, במענה להודעה במילה "הסר", או בפנייה ל-
                    <a href="mailto:support@zmanup.co.il">support@zmanup.co.il</a>.
                    <br />
                    7.4 ZmanUp אינה שולחת דברי פרסומת משלה ללקוחות קצה. הודעות שעסק שולח ללקוחותיו באמצעות השירות הן באחריות העסק, והוא אחראי לקבל את הסכמתם כנדרש בדין.
                </p>

                <h2 className="privacy-policy-heading">8. קובצי Cookies</h2>
                <p className="privacy-policy-text">
                    אנו משתמשים בקובצי Cookies ובטכנולוגיות דומות:
                    <br />
                    • Cookies חיוניים – להתחברות, לאבטחה ולשמירת העדפות. בלעדיהם חלק מהשירות לא יפעל.
                    <br />
                    • Cookies לניתוח – באמצעות Google Analytics, לצורך הבנת אופן השימוש באתר ושיפורו. מדיניות הפרטיות של Google: https://policies.google.com/privacy
                    <br />
                    ניתן לחסום או למחוק קובצי Cookies בהגדרות הדפדפן, אולם הדבר עלול לפגוע בחלק מהפונקציות.
                </p>

                <h2 className="privacy-policy-heading">9. מידע מחשבון Google</h2>
                <p className="privacy-policy-text">
                    9.1 אם בחרת לחבר את חשבון ה-Google שלך, ZmanUp מקבלת גישה רק למידע ההכרחי לסנכרון התורים: כתובת הדוא"ל ואירועי לוח השנה (קריאה, יצירה ועדכון של אירועים).
                    <br />
                    9.2 המידע משמש אך ורק לסנכרון התורים בין ZmanUp לבין לוח השנה שלך. ZmanUp אינה מעבירה מידע שהתקבל מ-Google לצדדים שלישיים (למעט ספקי תשתית הנדרשים להפעלת השירות), אינה משתמשת בו לפרסום ואינה משתמשת בו לאימון מודלים של בינה מלאכותית.
                    <br />
                    9.3 השימוש של ZmanUp במידע המתקבל מממשקי Google API והעברתו לכל אפליקציה אחרת יעמדו במדיניות Google API Services User Data Policy, לרבות דרישות ה-Limited Use: https://developers.google.com/terms/api-services-user-data-policy
                    <br />
                    9.4 ניתוק חשבון ה-Google מהשירות יביא למחיקה אוטומטית של המידע שהתקבל מ-Google בתוך 30 יום. ניתן גם לבקש מחיקה ידנית בפנייה ל-
                    <a href="mailto:support@zmanup.co.il">support@zmanup.co.il</a>, והבקשה תטופל בתוך 14 ימי עסקים. ניתן לבטל את הגישה גם בהגדרות חשבון ה-Google: https://myaccount.google.com/permissions
                </p>

                <h2 className="privacy-policy-heading">10. שיתוף מידע עם צדדים שלישיים</h2>
                <p className="privacy-policy-text">
                    איננו מוכרים מידע אישי. אנו משתפים מידע רק במקרים הבאים:
                    <br />
                    • עם העסק – פרטי תור שלקוח קצה קבע מועברים לעסק שאצלו נקבע התור.
                    <br />
                    • עם ספקי שירות הפועלים מטעמנו ולפי הוראותינו, בקטגוריות הבאות: אחסון ותשתית ענן; שליחת SMS, הודעות WhatsApp ודוא"ל; התראות push; ניתוח שימוש; ניטור תקלות; סליקה ותשלומים. ספקים אלה רשאים להשתמש במידע רק לצורך מתן השירות לנו.
                    <br />
                    • על פי דין – כאשר הדבר נדרש לפי חוק, צו שיפוטי או דרישה של רשות מוסמכת, או לשם הגנה על זכויותינו ועל ביטחון המשתמשים.
                    <br />
                    • בשינוי מבני – במקרה של מיזוג, רכישה או העברת הפעילות, בכפוף להתחייבות הגורם הנעבר לנהוג במידע בהתאם למדיניות זו.
                    <br />
                    רשימה עדכנית של ספקי השירות זמינה לפי בקשה בפנייה ל-
                    <a href="mailto:support@zmanup.co.il">support@zmanup.co.il</a>.
                </p>

                <h2 className="privacy-policy-heading">11. אחסון המידע והעברתו אל מחוץ לישראל</h2>
                <p className="privacy-policy-text">
                    המידע נשמר ומעובד בשרתים הממוקמים בישראל. חלק מספקי השירות המפורטים בסעיף 10 (כגון שירותי ניתוח שימוש, שליחת הודעות והתראות push) עשויים לעבד מידע מחוץ לישראל, במידה הנדרשת למתן שירותם בלבד. במקרים אלה המידע מועבר בהתאם לתקנות הגנת הפרטיות (העברת מידע אל מאגרי מידע שמחוץ לגבולות המדינה), התשס"א-2001.
                </p>

                <h2 className="privacy-policy-heading">12. שמירת מידע</h2>
                <p className="privacy-policy-text">
                    • המידע נשמר כל עוד החשבון פעיל, ובמידה הנדרשת למתן השירות.
                    <br />
                    • לאחר סגירת חשבון עסקי, המידע של המשתמש העסקי ושל לקוחותיו יימחק בתוך 30 יום, ומהגיבויים – בתוך 30 יום נוספים, במסגרת המחזור השוטף של הגיבויים.
                    <br />
                    • מידע הנדרש לפי דין לצורכי הנהלת החשבונות של ZmanUp – כגון פרטי המנוי, חשבוניות וקבלות שהופקו למשתמש העסקי ואישורי תשלום – יישמר גם לאחר סגירת החשבון, לתקופה הנדרשת בדין (בדרך כלל 7 שנים).
                    <br />
                    • מסמכים חשבונאיים שהמשתמש העסקי מפיק ללקוחותיו באמצעות השירות (כגון קבלות וחשבוניות) מופקים ונשמרים אצל ספק הפקת המסמכים שבחר העסק. באחריות המשתמש העסקי לשמור את המסמכים בהתאם לדין, ומומלץ לייצא את נתוני העסק לפני סגירת החשבון.
                    <br />
                    • מידע שהתקבל מ-Google – כמפורט בסעיף 9.4.
                </p>

                <h2 className="privacy-policy-heading">13. אבטחת מידע</h2>
                <p className="privacy-policy-text">
                    אנו נוקטים אמצעים ארגוניים וטכנולוגיים להגנה על המידע, בהתאם לתקנות הגנת הפרטיות (אבטחת מידע), התשע"ז-2017, ובהם הצפנת התקשורת, הצפנת מידע רגיש (כגון תשובות לשאלונים וטפסים שמולאו) בעת האחסון ובגיבויים, גישה לקבצים רק למשתמשים מורשים, בקרת גישה והרשאות לפי הצורך, וגיבוי. במקרה של אירוע אבטחה חמור נפעל בהתאם לדין, לרבות דיווח לרשות להגנת הפרטיות ועדכון המשתמשים כנדרש. עם זאת, אין מערכת חסינה לחלוטין, ולא ניתן להבטיח הגנה מלאה מפני גישה בלתי מורשית.
                </p>

                <h2 className="privacy-policy-heading">14. זכויותיך</h2>
                <p className="privacy-policy-text">
                    בהתאם לחוק הגנת הפרטיות, התשמ"א-1981, באפשרותך:
                    <br />
                    • לעיין במידע עליך המוחזק אצלנו (סעיף 13 לחוק);
                    <br />
                    • לבקש לתקן או למחוק מידע שאינו נכון, שלם, ברור או מעודכן (סעיף 14 לחוק);
                    <br />
                    • לבקש לסגור את חשבונך ולמחוק את המידע בהתאם למדיניות שמירת המידע שלנו ובכפוף לחובות שמירה על פי דין;
                    <br />
                    • לבטל בכל עת את הסכמתך לקבלת דברי פרסומת (סעיף 7).
                    <br />
                    בקשות יש לשלוח ל-
                    <a href="mailto:support@zmanup.co.il">support@zmanup.co.il</a>. נשיב לבקשה בתוך 30 יום. ייתכן שנבקש לאמת את זהותך לפני הטיפול בבקשה. לקוחות קצה – ראו סעיף 2.2.
                </p>

                <h2 className="privacy-policy-heading">15. גיל</h2>
                <p className="privacy-policy-text">
                    פתיחת חשבון עסקי בשירות מותרת לבני 18 ומעלה בלבד.
                </p>

                <h2 className="privacy-policy-heading">16. שינויים במדיניות</h2>
                <p className="privacy-policy-text">
                    אנו רשאים לעדכן מדיניות זו מעת לעת. על שינויים מהותיים נודיע למשתמשים העסקיים בדוא"ל או בהודעה בשירות, לפחות 14 יום לפני כניסתם לתוקף. תאריך העדכון האחרון מופיע בראש המדיניות.
                </p>

                <h2 className="privacy-policy-heading">17. שפה</h2>
                <p className="privacy-policy-text">
                    המדיניות עשויה להיות מוצגת גם בשפות נוספות. במקרה של סתירה בין הנוסחים, הנוסח העברי הוא הקובע.
                </p>

                <h2 className="privacy-policy-heading">18. הדין החל וסמכות שיפוט</h2>
                <p className="privacy-policy-text">
                    על מדיניות זו יחולו דיני מדינת ישראל. סמכות השיפוט תהיה לבתי המשפט המוסמכים בישראל, בהתאם להוראות הדין.
                </p>

                <h2 className="privacy-policy-heading">19. יצירת קשר</h2>
                <p className="privacy-policy-text">
                    לשאלות בנוגע למדיניות זו או למימוש זכויותיך:{' '}
                    <a href="mailto:support@zmanup.co.il">support@zmanup.co.il</a>
                </p>
            </article>
        </main>
    );
}